import { Create } from '@fund/api-modules';
import { getApiHostWithoutEnv } from '@fund/api-host';
import CreateByUser from './decorator/CreateByUser';

import NewsModel from '../model/news.model';
import TransformResponse from './decorator/TransformResponse';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken,
      ctoken,
      uid,
      deviceid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      version: '6.5.5',
      customerNo: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})
@Create({
  baseURL: getApiHostWithoutEnv('appnews'), // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'web',
  },
})
class NewsApi {
  @TransformResponse((res) => NewsModel.objectArrayWithKeyValuesArray(res.Data.List || []))
  getNews(FCODE) {
    // https://appnews.1234567.com.cn/api/AppService/GetFundRelatedArticle?fundCodes=000001&passportId=&Key=52877e88-62ef-8bc5-91a0-98c9ffcdb3bc&AppVersion=6.2.5&DeviceId=EABB8E88-FD9D-4932-8F9D-FC262FC0BFD8&pageIndex=1&scene=detail&Plat=IOS&EntryType=1&OSVersion=10.3.1&GTOKEN=3C39409521AE467B857E194D70BA5Ae1&pageSize=2
    return this.POST('/api/AppService/GetFundRelatedArticle', {
      fundCodes: FCODE,
      Key: '52877e88-62ef-8bc5-91a0-98c9ffcdb3bc',
      pageIndex: '1',
      scene: 'detail',
      EntryType: '1',
      pageSize: '2',
    });
  }
}
export default new NewsApi();
